import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SETAHeroSection from './components/SETAHeroSection';
import UnderstandingSETASection from './components/UnderstandingSETASection';
import ComplianceDeadlinesSection from './components/ComplianceDeadlinesSection';
import SDFRoleSection from './components/SDFRoleSection';
import WSPATRSection from './components/WSPATRSection';
import MandatoryDiscretionarySection from './components/MandatoryDiscretionarySection';
import BBBEESection from './components/BBBEESection';
import SylmanSupportSection from './components/SylmanSupportSection';
import ComplianceChecklistSection from './components/ComplianceChecklistSection';
import ResourcesSection from './components/ResourcesSection';
import ExpertHelpSection from './components/ExpertHelpSection';

const complianceSteps = [
  { step: '01', title: 'Clarify obligations', text: 'Understand what applies to your organisation, sector and reporting cycle.' },
  { step: '02', title: 'Prepare WSP/ATR', text: 'Gather training evidence, plans and workplace skills development priorities.' },
  { step: '03', title: 'Unlock support', text: 'Use grants, accredited training and SDF guidance to turn compliance into capability.' },
];

export default function SETACompliancePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <SETAHeroSection />
        <section className="section-wrap-sm bg-[#f8f9fa] border-b border-[#e8eaea]">
          <div className="section-inner">
            <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-10 items-start">
              <div>
                <p className="section-label">Compliance roadmap</p>
                <h2 className="section-heading">From paperwork to measurable skills development</h2>
                <p className="section-body">
                  SETA compliance becomes easier when the process is broken into clear decisions, practical documentation and training that supports the business.
                </p>
              </div>
              <div className="grid md:grid-cols-3 gap-4">
                {complianceSteps.map(item => (
                  <div key={item.step} className="card p-5">
                    <div className="mb-4 font-serif text-3xl text-[#2D7F3E]">{item.step}</div>
                    <h3 className="font-sans text-sm font-semibold text-[#111111] mb-2">{item.title}</h3>
                    <p className="text-xs leading-relaxed text-[#6b7280]">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <UnderstandingSETASection />
        <ComplianceDeadlinesSection />
        <SDFRoleSection />
        <WSPATRSection />
        <MandatoryDiscretionarySection />
        <BBBEESection />
        <SylmanSupportSection />
        <ComplianceChecklistSection />
        <ResourcesSection />
        <ExpertHelpSection />
      </main>
      <Footer />
    </div>
  );
}
